export class ApiProfileDescriptor {
  public id: string;
  public userName: string;
  public fullName: string;
  public emailAddress: string;
  public phoneNumber: string;
  public baseRoleType: string;
  public mandatoryUpdate: boolean;
  public calendarEventNotificationByEmail: boolean;
  public calendarEventNotificationBySms: boolean;
  public modified: Date;
  public deleted: Date;

  public href: string;
}




// WEBPACK FOOTER //
// ./src/app/modules/profile/model/api.profile.ts